require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-atish-the-rio-rooftop.json") })
        }
      }, "path---interview-atish-the-rio-rooftop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-atish-the-rio-rooftop!./.cache/json/interview-atish-the-rio-rooftop.json
// module id = 655
// module chunks = 231608221292675